<template>
  <div v-bind:class="{'main-content' : !taskId}">
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loading">
          <div class="row">
            <div class="col-md-6">
              <table class="table table-sm table-hover">
                <tbody>
                <tr>
                  <td class="bold">ID</td>
                  <td>{{ task.drug.id }}</td>
                </tr>
                <tr>
                  <td class="bold">Название</td>
                  <td>{{ task.drug.title }}</td>
                </tr>
                <tr>
                  <td class="bold">Alias</td>
                  <td>{{ task.drug.en_title }}</td>
                </tr>
                <tr>
                  <td class="bold">Рубрика</td>
                  <td></td>
                </tr>
                <tr>
                  <td class="bold" colspan="2">Цены</td>
                </tr>
                <tr v-for="price in getSitePrices()">
                  <td colspan="2">от {{ price.qty }} - {{ price.price }} руб</td>
                </tr>
                <tr>
                  <td class="bold" colspan="2">Список переменных в описании</td>
                </tr>
                <tr v-for="detail in baseSiteDetails">
                  <td class="bold">{{ detailsData[detail.detail_id].title }}</td>
                  <td>{{ detail[detail.type + '_value'] }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-6">
              <p>Приоритет: <span :class="`priority priority-${task.drug.priority}`"/></p>
              <p>Ключевые слова:</p>
              <p>{{ task.drug.keywords }}</p>
            </div>
          </div>
        </template>
      </div>
    </div>
    <template v-if="task">
      <form action="" @submit.prevent="saveRecords">
        <div class="card" v-for="projectId in task.task_data.selected_projects">
          <div class="card-header bg-info">
            <h5>Создание препарата на <strong>{{ $AllProjects[projectId].title }} ({{ projectId }})</strong></h5>
          </div>
          <div class="card-body" v-if="newDrugsData[projectId]">
            <div class="form-group">
              <label for="">Название препарата</label>
              <input required type="text" v-model="newDrugsData[projectId][4].text_value" class="form-control">
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for=""><strong>ЧПУ препарата</strong></label>
                  <input required type="text" v-model="newDrugsData[projectId][1].text_value" class="form-control">
                </div>
                <div>
                  <p><strong>Ценовые диапазоны</strong></p>
                  <div class="input-group mb-1" v-for="(price, i) in newDrugsData[projectId].prices">
                    <template v-if="i === 0 || $AllProjects[projectId].settings?.use_diff_price">
                      <div class="input-group-prepend">
                        <span class="input-group-text">От</span>
                        <input v-model="price.qty" type="number" :disabled="i === 0" class="form-control">
                        <span class="input-group-text">цена</span>
                      </div>
                      <template v-if="projectsFixedPrices.includes(projectId) && Object.values(egkRates).length">
                        <input type="number"
                               disabled
                               :value="price.price * (price.rate ?? 1) / (price.packing ?? 1)"
                               class="form-control">
                      </template>
                      <template v-else>
                        <input type="number"
                               v-model="price.price "
                               class="form-control">
                      </template>
                    </template>
                  </div>
                </div>
                <div>
                  <p><strong>Категория</strong></p>
                  <pulse-loader :loading="loadingCategories" :color="$constants.LOADING_COLOR" class="text-center"/>
                  <template v-if="!loadingCategories">
                    <template v-if="siteSelects[projectId] && siteSelects[projectId].categories">
                      <multiselect
                        name="category"
                        v-model="newDrugsData[projectId][5].selectedCategories"
                        :options="siteSelects[projectId].categories"
                        @input="(e) => selectCategory(e, projectId)"
                        placeholder="Выберите категорию"
                        track-by="name"
                        label="name"
                        :showLabels="true"
                        :searchable="true"
                        :multiple="true">
                      </multiselect>
                    </template>
                  </template>
                </div>
              </div>
              <div class="col-md-8">
                <table class="table table-sm table-hover">
                  <tbody>
                  <tr v-for="(value, field) in siteFileds[projectId]" v-if="detailsData[field]">
                    <td class="bold">{{ detailsData[field].title }}</td>
                    <td>
                      <template v-if="detailsData[field].type === 'text'">
                        <input type="text" v-model="newDrugsData[projectId][field].text_value" class="form-control">
                      </template>
                      <template v-if="detailsData[field].type === 'int'">
                        <select v-model="newDrugsData[projectId][field].int_value" class="form-control">
                          <option v-for="opt in newDrugsData[projectId][field].options"
                                  :value="opt.id || opt.title || opt.name || opt.value || opt ">
                            {{ opt.title || opt.text || opt.name || opt }}
                          </option>
                        </select>
                      </template>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="mt-1" v-if="projectId === 12">
              <div v-for="(er, code, iii) in egkRates" class="input-group">
                <input type="text" disabled :value="er.egk_id" class="form-control">
                <input type="text" disabled :value="er.egk_code.title" class="form-control w-50">
                <template v-if="iii === 0">
                  <input type="text" disabled value="К1" class="form-control">
                  <input @change="updateRatePrices" type="text" v-model="er.rate_1" class="form-control">
                  <input type="text" disabled value="К2" class="form-control">
                  <input @change="updateRatePrices" type="text" v-model="er.rate_2" class="form-control">
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body text-right">
            <LoadingButton
              title="Создать препараты"
              :loading="saveLoading"
              type="submit"
              :onClick="() => {}"
              className="btn btn-success"
            />
          </div>
        </div>
      </form>
    </template>
  </div>
</template>

<script>

import api from "@/api"
import Multiselect from 'vue-multiselect'
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  props: ['taskId', 'closeModal'],
  components: {
    Multiselect,
    LoadingButton,
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      loadingCategories: false,
      task: null,
      drugData: null,
      projectsFixedPrices: [7, 12, 13],
      actualEgkRate: {},
      egkRates: {},
      baseSiteDetails: null,
      detailsData: null,
      newDrugsData: {},
      siteFileds: {},
      siteSelects: {},
    }
  },
  computed: {
    $AllProjects() {
      const sites = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return sites;
    },
  },
  created() {
    if (this.taskId) {
      this.getTask();
    }
  },
  methods: {
    updateRatePrices() {
      const rate = Object.values(this.egkRates)[0];
      this.projectsFixedPrices.forEach((pId) => {
        // if (!this.newDrugsData[pId]) this.newDrugsData[pId] = {prices: [{site_id: pId, qty: 1, price: 0}]}
        if (!this.newDrugsData[pId]) return;
        this.newDrugsData[pId].prices.forEach((p, i) => {
          // this.newDrugsData[pId].prices[i].price = Math.round(+this.newDrugsData[pId].prices[i].price * +(rate.rate_1 ?? 1) / +(rate.rate_2 ?? 1));
          this.newDrugsData[pId].prices[i].price = +this.newDrugsData[pId].prices[i].price;
          this.newDrugsData[pId].prices[i].rate = +(rate.rate_1 ?? 1);
          this.newDrugsData[pId].prices[i].packing = +(rate.rate_2 ?? 1);
        })
      })
    },
    async saveRecords() {
      const errorMessage = [];
      const packSet = +this.task.drug.pack_set;
      Object.keys(this.newDrugsData).forEach((projectId) => {
        if (!this.newDrugsData[projectId]) {
          errorMessage.push('Проект: ' + this.$AllProjects[projectId].title + ' - нет данных');
          return;
        }
        this.newDrugsData[projectId].prices.forEach((p) => {
          if ((+p.qty === 1 && (!p.price || p.price < 0)) || (p.price < 0 || p.qty <= 0)) {
            errorMessage.push('Проект: ' + this.$AllProjects[projectId].title + ' - недопустимая цена для количества ' + p.qty);
          }
          if (p.price % packSet !== 0) {
            errorMessage.push('Цена ' + p.price + ' не кратна ' + packSet);
          }
        })
        if (!this.newDrugsData[projectId][5].array_value.length) {
          errorMessage.push('Проект: ' + this.$AllProjects[projectId].title + ' - нет выбранной категории');
        }
      })

      if (errorMessage.length) {
        errorMessage.forEach((m) => {
          toastr['warning'](m, 'Ошибка!');
        })
        return;
      }

      const drugsData = {...this.newDrugsData};

      if (!drugsData[4]) {
        const prices = this.getSitePrices();
        drugsData[4] = {
          prices: [{
            site_id: 4,
            qty: 1,
            price: prices[0].price
          }]
        }
      }
      if (drugsData[12] && !drugsData[13]) {
        drugsData[13] = {prices: [{...drugsData[12].prices[0], site_id: 13}]}
      }

      this.saveLoading = true;
      const {data} = await api.post('/new/drugs/create', {
        drugsData,
        task_id: this.task.id
      })
      if (data.success) {
        toastr['success'](data.message || 'Сохранено!');
        if (this.closeModal) {
          this.closeModal();
        }
      } else {
        (data && data.errors || [false]).forEach((e) => {
          if (e) {
            let message = this.$AllProjects[e.project_id] && this.$AllProjects[e.project_id].title || e.project_id;
            message += ' ' + e.message;
            toastr['warning'](message);
          } else {
            toastr['warning'](data.message || 'Ошибка!');
          }
        })
      }
      this.saveLoading = false;
    },
    selectCategory(cat, projectId) {
      this.newDrugsData[projectId][5].array_value = cat && cat.map((c) => c.id) || [];
    },
    getSitePrices() {
      const prices = this.task.drug.prices.filter((p) => p.site_id === 1);
      return _.orderBy(prices, 'qty');
    },
    async getTask() {
      this.loading = true;
      const {data} = await api.index('/tasks/' + this.taskId);
      if (data.success) {
        this.task = data.task;
        const platformDrugDetails = data.task.drug.details.reduce((acc, d) => {
          if (!acc[d.group_alias]) acc[d.group_alias] = {}
          acc[d.group_alias][d.alias] = d;
          return acc;
        }, {})
        const savedDetails = data.details.reduce((acc, d) => {
          acc[d.detail_id] = {...d};
          return acc;
        }, {})
        const slug = data.slug;
        this.newDrugsData = Object.keys(data.siteFileds).reduce((acc, projectId) => {
          if (!this.task.task_data.selected_projects.includes(+projectId)) {
            return acc;
          }
          acc[projectId] = {};
          acc[projectId][1] = {id: 1, type: 'text', text_value: slug}; // drug slug
          acc[projectId][4] = {id: 4, type: 'text', text_value: this.task.drug.title}; // drug title
          acc[projectId][5] = {id: 5, type: 'array', array_value: []}; // drug categories

          Object.keys(data.siteFileds[projectId]).forEach((detId) => {
            if (data.siteBaseDetails[detId]) {
              acc[projectId][detId] = {...data.siteBaseDetails[detId]};
              if (savedDetails[detId]) {
                acc[projectId][detId][savedDetails[detId].type + '_value'] = savedDetails[detId][savedDetails[detId].type + '_value']
              }
              const platformData = this.getPlatformSavedData(platformDrugDetails, acc[projectId][detId]);
              if (platformData) {
                acc[projectId][detId][platformData.key] = platformData.value;
              }
            }
            acc[projectId].prices = this.task.drug.prices.reduce((acc, p) => {
              if (p.site_id === 1) {
                acc.push({
                  site_id: projectId,
                  qty: p.qty,
                  price: p.price
                })
              }
              return _.orderBy(acc, 'qty');
            }, [])
          })
          return acc;
        }, {})
        this.baseSiteDetails = data.details;
        this.detailsData = data.siteBaseDetails;
        this.siteFileds = data.siteFileds;
        this.egkRates = data.egkRates;
        this.actualEgkRate = Object.values(data.egkRates).find((r) => (r.rate_1 && r.rate_1 !== 1) || (r.rate_2 && r.rate_2 !== 1));
        this.updateRatePrices();
        this.getSiteData();
      } else {
        toastr['warning'](data.message || 'Ошибка!');
      }
      this.loading = false;
    },
    async getSiteData() {
      this.loadingCategories = true;
      const {data} = await api.post('/new/drugs/siteInfo', {
        site_ids: [...this.task.task_data.selected_projects, 1]
      })
      if (data.success) {
        this.siteSelects = data.siteData;
      } else {
        toastr['warning'](data.message || 'Ошибка загрузки данных с сайтов');
      }
      this.loadingCategories = false;
    },
    getPlatformSavedData(platformDrugDetails, projectDetail) {
      switch (projectDetail.alias) {
        case 'prescription':
          if (platformDrugDetails.recipe) {
            return {key: 'int_value', value: platformDrugDetails.recipe.no_use.int_value ? 2 : 1}
          }
          break;
      }
      return false;
    }
  }
}

</script>

<style scoped>
.table {
  margin-top: 0;
}

.table td {
  padding: 3px 5px;
}

.bold {
  font-weight: 600;
}

.card {
  margin-bottom: 5px;
}

.input-group-prepend {
  max-width: 175px;
}
</style>
